<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="lmodel !== null">
    <TabView class="setting-layout">
      <!-- Setting -->
      <TabPanel header="Settings">
        <div class="grid">
          <div class="col-12 lg:col-11">
            <span class="general-settings-text">
              {{
              staticData.settings.deal_img
              }}
            </span>
          </div>
          <div class="col-12 lg:col-1">
            <label>
              <div class="toggle-button toggleblock-btn">
                <span
                  :class="{
                    'toggle-on': displayimgwidget,
                    'toggle-off': !displayimgwidget,
                  }"
                  @click="displayimgwidget = !displayimgwidget"
                ></span>
              </div>
            </label>
          </div>
        </div>
        <div>
          <div class="grid col-12" v-if="displayimgwidget">
            <span class="general-settings-text">
              {{
              staticData.settings.img_src
              }}
            </span>
          </div>
          <div class="grid" v-if="displayimgwidget">
            <div class="col-12">
              <div class="border-box">
                <PrimeButton
                  label="Image archive"
                  class="rwd-btn"
                  @click="selectImgType('imgarchive')"
                  :class="{ 'active-btn': selectedImgType === 'imgarchive' }"
                  id="imgarchive"
                ></PrimeButton>

                <PrimeButton
                  label="Image url"
                  class="rwd-btn1"
                  @click="selectImgType('imgurl')"
                  :class="{ 'active-btn': selectedImgType === 'imgurl' }"
                  id="imgurl"
                ></PrimeButton>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Side -->
        <div
          class="grid"
          v-if="
            selectedImgType === 'imgarchive' &&
            displayimgwidget &&
            selectedDeviceType == 'mobile'
          "
        >
          <div
            :class="
              vmodel1.ambmobHeaderimagepath === null ||
              vmodel1.ambmobHeaderimagepath === ''
                ? 'field col-12 photo-container1'
                : 'field col-12 photo-container'
            "
          >
            <div
              :class="
                vmodel1.ambmobHeaderimagepath === null ||
                vmodel1.ambmobHeaderimagepath === ''
                  ? 'photo-sectionimg cursor-pointer'
                  : 'photo-section cursor-pointer'
              "
            >
              <div v-if="!cropperIsActiveMaxWidMob">
                <img
                  v-if="
                    vmodel1.ambmobHeaderimagepath !== '' &&
                    vmodel1.ambmobHeaderimagepath !== null
                  "
                  :src="vmodel1.ambmobHeaderimagepath"
                  alt
                  class="imagefit"
                />
              </div>
              <FileUpload
                type="file"
                id="fileidmobile"
                ref="filemobile"
                accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff"
                @select="handleFileUpload($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />

              <div
                v-if="
                  !cropperIsActiveMaxWidMob &&
                  (vmodel1.ambmobHeaderimagename == null ||
                    vmodel1.ambmobHeaderimagename == '')
                "
                class="upload-icon"
              ></div>
              <span
                v-if="
                  !cropperIsActiveMaxWidMob &&
                  (vmodel1.ambmobHeaderimagename == null ||
                    vmodel1.ambmobHeaderimagename == '')
                "
              >{{ staticData.settings.dropImg }}</span>

              <PrimeButton
                v-if="
                  !cropperIsActiveMaxWidMob &&
                  (vmodel1.ambmobHeaderimagename == null ||
                    vmodel1.ambmobHeaderimagename == '')
                "
                label="Browse"
                class="browse-btn"
                icon="pi pi-folder-open"
                @click="openFileUploadMobile"
              />
              <div class="mt-2">
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidMob &&
                    vmodel1.ambmobHeaderimagename !== null &&
                    vmodel1.ambmobHeaderimagename !== ''
                  "
                  label="Replace"
                  class="replace-button"
                  @click="replaceFileMobile"
                  icon="fa fa-undo"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidMob &&
                    vmodel1.ambmobHeaderimagename !== null &&
                    vmodel1.ambmobHeaderimagename !== ''
                  "
                  label="Clear"
                  class="clear-button ml-2"
                  @click="clearImageMobile()"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidMob &&
                    vmodel1.ambmobHeaderimagename !== null &&
                    vmodel1.ambmobHeaderimagename !== ''
                  "
                  label="Crop"
                  class="crop-button ml-2"
                  @click="cropImageMaxMobile()"
                  icon="fa fa-refresh"
                />
                <cropper
                  v-if="cropperIsActiveMaxWidMob"
                  class="imagefit"
                  :src="vmodel1.ambmobHeaderimagepath"
                  :auto-zoom="true"
                  ref="cropperComponent5"
                />
              </div>
              <div class="mt-3 mb-2">
                <PrimeButton
                  v-if="cropperIsActiveMaxWidMob"
                  label="Clear"
                  class="clear-button mt-2"
                  @click="closeCropperMaxWidMob"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="cropperIsActiveMaxWidMob"
                  label="Submit"
                  class="submit-button mt-2 ml-2"
                  @click="captureCroppedImageMaxWidMob"
                  icon="fa fa-check"
                />
              </div>
              <!-- <FileUpload
                ref="photo"
                name="photo"
                accept=".png, .jpg,.jpeg,.gif"
                @select="onAdvancedUpload($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />-->
            </div>
          </div>
        </div>
        <!-- Mobile End -->

        <!-- Desktop Side -->

        <div
          class="grid"
          v-if="
            selectedImgType === 'imgarchive' &&
            displayimgwidget &&
            selectedDeviceType == 'desktop'
          "
        >
          <div
            :class="
              vmodel1.ambheaderimagepath === null ||
              vmodel1.ambheaderimagepath === ''
                ? 'field col-12 photo-container1'
                : 'field col-12 photo-container'
            "
          >
            <div
              :class="
                vmodel1.ambheaderimagepath === null ||
                vmodel1.ambheaderimagepath === ''
                  ? 'photo-sectionimg cursor-pointer'
                  : 'photo-section cursor-pointer'
              "
            >
              <div v-if="!cropperIsActiveMaxWidDesk">
                <img
                  v-if="
                    vmodel1.ambheaderimagepath !== '' &&
                    vmodel1.ambheaderimagepath !== null
                  "
                  :src="vmodel1.ambheaderimagepath"
                  alt
                  class="imagefit"
                />
              </div>
              <FileUpload
                type="file"
                id="fileiddesktop"
                ref="filedesktop"
                accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff"
                @select="handleFileUploadDesktop($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />
              <div
                v-if="
                  !cropperIsActiveMaxWidDesk &&
                  (vmodel1.ambheaderimagename == null ||
                    vmodel1.ambheaderimagename == '')
                "
                class="upload-icon"
              ></div>
              <span
                v-if="
                  !cropperIsActiveMaxWidDesk &&
                  (vmodel1.ambheaderimagename == null ||
                    vmodel1.ambheaderimagename == '')
                "
              >{{ staticData.settings.dropImg }}</span>
              <PrimeButton
                v-if="
                  !cropperIsActiveMaxWidDesk &&
                  (vmodel1.ambheaderimagename == null ||
                    vmodel1.ambheaderimagename == '')
                "
                label="Browse"
                class="browse-btn"
                icon="pi pi-folder-open"
                @click="openFileUploadDesktop"
              />
              <div class="mt-2">
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidDesk &&
                    vmodel1.ambheaderimagename !== null &&
                    vmodel1.ambheaderimagename !== ''
                  "
                  label="Replace"
                  class="replace-button"
                  @click="replaceFileDesktop"
                  icon="fa fa-undo"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidDesk &&
                    vmodel1.ambheaderimagename !== null &&
                    vmodel1.ambheaderimagename !== ''
                  "
                  label="Clear"
                  class="clear-button ml-2"
                  @click="clearImageDesktop()"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidDesk &&
                    vmodel1.ambheaderimagename !== null &&
                    vmodel1.ambheaderimagename !== ''
                  "
                  label="Crop"
                  class="crop-button ml-2"
                  @click="cropImageMaxDesktop()"
                  icon="fa fa-crop"
                />

                <cropper
                  v-if="cropperIsActiveMaxWidDesk"
                  class="imagefit"
                  :src="vmodel1.ambheaderimagepath"
                  :auto-zoom="true"
                  ref="cropperComponent6"
                />
              </div>
              <div class="mt-3 mb-2">
                <PrimeButton
                  v-if="cropperIsActiveMaxWidDesk"
                  label="Clear"
                  class="clear-button mt-2"
                  @click="closeCropperMaxWidDesk"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="cropperIsActiveMaxWidDesk"
                  label="Submit"
                  class="submit-button mt-2 ml-2"
                  @click="captureCroppedImageMaxWidDesk"
                  icon="fa fa-check"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Desktop End -->
        <div class="grid" v-if="imgurl && displayimgwidget">
          <div class="col-12 lg:col-12">
            <label
              for="minwidOffsetDesktopHor"
              class="control-label"
              :isRequiredLabel="false"
            >{{ staticData.settings.img_url }}</label>
            <InputText v-model="imgurlval" id="minwidOffsetDesktopHor" class="mt-1"></InputText>
          </div>
        </div>

        <div>
          <div class="grid col-12 mt-2">
            <span class="general-settings-text">
              {{
              staticData.settings.layout
              }}
            </span>
          </div>

          <div class="grid">
            <div class="col-12">
              <div class="border-box">
                <PrimeButton
                  label="Image to the left"
                  class="rwd-btn"
                  @click="selectWidgetType('text')"
                  :class="{ 'active-btn': selectedWidgetType === 'text' }"
                  id="text"
                ></PrimeButton>

                <PrimeButton
                  label="Image to the right"
                  class="rwd-btn1"
                  @click="selectWidgetType('image')"
                  :class="{ 'active-btn': selectedWidgetType === 'image' }"
                  id="img"
                ></PrimeButton>
              </div>
            </div>
          </div>
        </div>

        <div class="grid mt-2">
          <div class="col-12 lg:col-11">
            <span class="general-settings-text">
              {{
              staticData.settings.img_border
              }}
            </span>
          </div>
          <div class="col-12 lg:col-1">
            <label>
              <div class="toggle-button toggleblock-btn">
                <span
                  :class="{
                    'toggle-on': imgBorder,
                    'toggle-off': !imgBorder,
                  }"
                  @click="imgBorder = !imgBorder"
                ></span>
              </div>
            </label>
          </div>
        </div>

        <div class="grid">
          <div class="col-12">
            <span class="general-settings-text">{{ staticData.settings.info_collection }}</span>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="emailText"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambToolTip"
            >{{ lmodel.ambHideOptinAmbassador }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambHideOptinAmbassador"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="
                  vmodel1.ambHideOptinAmbassador == true
                    ? [
                        (vmodel1.ambShowEmail = false),
                        (vmodel1.ambShowPhoneNumber = false),
                        (vmodel1.ambShowPersonalNumber = false),
                        (vmodel1.ambIsRequireAmbassadorName = false),
                        (vmodel1.ambIsRequireFNameLName = false),
                        (vmodel1.ambEnableBirthday = false),
                        (vmodel1.ambEnableCustomTextField = false),
                        (vmodel1.ambEnableSingleSelectOptions = false),
                        (vmodel1.ambEnableConsents = false),
                        (vmodel1.ambrevfcc = false),
                      ]
                    : (vmodel1.ambShowEmail = true)
                "
              />
              <!-- <span
                  :class="{
                    'toggle-on': hideoptamb,
                    'toggle-off': !hideoptamb,
                  }"
                  @click="toggleHideoptamb()"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="emailText"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambShowEmailToolTip"
            >{{ lmodel.ambShowEmail }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambShowEmail"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="showEmailval()"
              />
              <!-- <span
                  :class="{
                    'toggle-on': emailButton,
                    'toggle-off': !emailButton,
                  }"
                  @click="emailButton = !emailButton"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid mb-1">
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambShowEmail">
            <label
              v-tooltip="lmodel.ambShowEmailToolTip"
              for="emailText-tooltip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.emailplaceholdertext }}</label>
            <InputRequiredText
              v-model="vmodel1.ambEmailText"
              type="text"
              id="EmailTitle"
              :placeholder="lmodel.ambEmailTextPlaceholder"
              v-tooltip="lmodel.showEmailToolTip"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambShowEmail"></div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="phoneNumber"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambassadorShowPhoneNumberToolTip"
            >{{ lmodel.ambShowPhoneNumber }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambShowPhoneNumber"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="showEmailval()"
              />
              <!-- <span
                  :class="{
                    'toggle-on': phoneNumber,
                    'toggle-off': !phoneNumber,
                  }"
                  @click="phoneNumber = !phoneNumber"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="personalNumber"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambassadorShowPersonalNumberToolTip"
            >{{ lmodel.ambShowPersonalNumber }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambShowPersonalNumber"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="showEmailval()"
              />
              <!-- <span
                  :class="{
                    'toggle-on': personNumber,
                    'toggle-off': !personNumber,
                  }"
                  @click="personNumber = !personNumber"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="fullName"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambRequireAmbassadorNameToolTip"
            >{{ lmodel.ambNameRequired }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambIsRequireAmbassadorName"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="
                  if (vmodel1.ambIsRequireAmbassadorName == true) {
                    vmodel1.ambIsRequireFNameLName = false;
                  }
                "
              />
              <!-- <span
                  :class="{
                    'toggle-on': fullName,
                    'toggle-off': !fullName,
                  }"
                  @click="toggleFullName"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="fNameLName"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambFNameLNameToolTip"
            >{{ lmodel.ambFNameLNameRequired }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambIsRequireFNameLName"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="
                  if (vmodel1.ambIsRequireFNameLName == true) {
                    vmodel1.ambIsRequireAmbassadorName = false;
                  }
                "
              />
              <!-- <span
                  :class="{
                    'toggle-on': fNameLName,
                    'toggle-off': !fNameLName,
                  }"
                  @click="toggleFNameLName"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="enableBirthdayToolTip"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambEnableBirthdayToolTip"
            >{{ lmodel.ambEnableBirthday }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambEnableBirthday"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': birthdayBtn,
                    'toggle-off': !birthdayBtn,
                  }"
                  @click="birthdayBtn = !birthdayBtn"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid mb-1">
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambEnableBirthday">
            <label
              v-tooltip="lmodel.ambBirthdayTitleToolTip"
              for="birthdayTitle-tooltip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.ambBirthdayTitle }}</label>
            <InputRequiredText
              v-model="vmodel1.ambbirthdayTitle"
              type="text"
              id="BirthdayTitle"
              :placeholder="lmodel.ambBirthdayTitlePlaceholder"
              v-tooltip="lmodel.showEmailToolTip"
              class="birthday-text"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambEnableBirthday"></div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="phoneNumber"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambEnableCustomTextFieldToolTip"
            >{{ lmodel.ambEnableCustomTextField }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambEnableCustomTextField"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': custom_field,
                    'toggle-off': !custom_field,
                  }"
                  @click="custom_field = !custom_field"
              ></span>-->
            </div>
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambEnableCustomTextField">
            <label
              v-tooltip="lmodel.ambCustomTextFieldTitleTooltip"
              for="customTextFieldTitle-tooltip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.ambCustomTextFieldTitle }}</label>
            <InputRequiredText
              :validation="valmodel.ambCustomTextFieldLabel"
              v-model="vmodel1.ambCustomTextFieldLabel"
              id="ambCustomTextFieldLabel"
              :PropName="lmodel.ambCustomTextFieldTitle"
              :placeholder="lmodel.ambCustomTextFieldTitlePlaceholder"
              class="mt-1"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambEnableCustomTextField">
            <label
              v-tooltip="lmodel.ambCustomTextFieldToolTip"
              for="customTextField-tooltip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.ambCustomTextField }}</label>
            <InputRequiredText
              :validation="valmodel.ambCustomTextField"
              v-model="vmodel1.ambCustomTextField"
              id="ambCustomTextField"
              :PropName="lmodel.ambCustomTextField"
              :placeholder="lmodel.ambCustomTextFieldPlaceholder"
              class="mt-1"
            ></InputRequiredText>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="electOptions"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambEnableSingleSelectOptionsToolTip"
            >{{ staticData.settings.choice }}</label>
          </div>

          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambEnableSingleSelectOptions"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': choicesBtn,
                    'toggle-off': !choicesBtn,
                  }"
                  @click="choicesBtn = !choicesBtn"
              ></span>-->
            </div>
          </div>
        </div>
        <!-- Vismay -->
        <div class="grid" v-if="vmodel1.ambEnableSingleSelectOptions">
          <div class="col-12 lg:col-12">
            <PrimeButton
              class="btn-add-select"
              @click="addSingleSelectOption"
              :disabled="vmodel1.ambEnableSelectOption.length >= 4"
              tabindex="-1"
              icon="pi pi-plus"
              label="New question"
            ></PrimeButton>
          </div>
        </div>
        <div class="grid col-12" v-if="vmodel1.ambEnableSingleSelectOptions">
          <div class="col-12 lg:col-12">
            <label class="general-settings-textnew">{{ staticData.settings.question }} {{ 1 }}</label>
          </div>

          <div class="col-12 lg:col-6">
            <label for="electOptions" class="general-settings-text">
              {{
              staticData.settings.que
              }}
            </label>
            <InputRequiredText
              v-model="
                  vmodel1.ambCustomTagsTitle
                "
              class="mt-2"
              autocomplete="nope"
              id="title"
              :placeholder="lmodel.ambCustomTextFieldTitlePlaceholder"
            />
          </div>
          <div class="col-12 lg:col-6">
            <label for="electOptions" class="general-settings-text">
              {{
              lmodel.ambCustomTextField
              }}
            </label>
            <InputRequiredText
              :validation="valmodel.ambCustomFieldName"
              v-model="
                  vmodel1.ambCustomFieldName
                "
              class="mt-2"
              :PropName="lmodel.ambCustomTextField"
              autocomplete="nope"
              id="title"
              :placeholder="lmodel.ambCustomTextFieldPlaceholder"
              @update:modelValue="validateCustomTag()"
            />
          </div>
          <!-- Toggle btn -->

          <!-- Req Ans -->

          <div class="col-3 toggle-button toggleblock-btn">
            <ToggleButton
              v-model="vmodel1.ambRequireAns"
              onIcon="toggle-on"
              offIcon="toggle-off"
              class="toggle-btn"
            />
            <label
              for="electOptions"
              class="general-settings-textnew ml-2"
            >{{ staticData.settings.req_ans }}</label>
          </div>

          <!-- Drop Down -->
          <div class="col-3 toggle-button toggleblock-btn">
            <ToggleButton
              v-model="vmodel1.ambDropdown"
              onIcon="toggle-on"
              offIcon="toggle-off"
              class="toggle-btn"
            />
            <label
              for="electOptions"
              class="general-settings-textnew ml-2"
            >{{ staticData.settings.dropdown }}</label>
          </div>

          <div class="col-3 toggle-button toggleblock-btn">
            <ToggleButton
              v-model="vmodel1.ambMultiAns"
              onIcon="toggle-on"
              offIcon="toggle-off"
              class="toggle-btn"
            />
            <label
              for="electOptions"
              class="general-settings-textnew ml-2"
            >{{ staticData.settings.multiple_ans }}</label>
          </div>
        </div>
        <div
          id="option-list"
          class="option-list grid col-12"
          style="margin-top: -17px"
          v-if="vmodel1.ambEnableSingleSelectOptions"
        >
          <div v-for="(ena, index) in vmodel.ambCustomtags" class="grid col-12" :key="index">
            <div class="col-12 lg:col-6">
              <label
                class="general-settings-textnew"
              >{{ staticData.settings.option }} {{ index + 1 }}</label>
            </div>
            <div class="col-12 lg:col-6" style="display: flex; justify-content: flex-end">
              <PrimeButton
                id="cancelbtn"
                name="Cancel"
                icon="pi pi-trash"
                @click="removeSingleComponentSelect(index)"
                label="Remove option"
                class="btn-danger"
              />
            </div>
            <div
              :class="
              index > 0
                ? 'col-12 lg:' +
                  (vmodel1.ambCustomtagstype == 1 || vmodel1.ambCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
                : 'col-12 lg:' +
                  (vmodel1.ambCustomtagstype == 1 || vmodel1.ambCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
            "
            >
              <label
                v-tooltip="lmodel.ambEnableLabelToolTip"
                tooltipvalueFor="ambEnableLabel-tooltip"
                labelclass="control-label"
              >{{lmodel.ambEnableLabel}}</label>
              <InputRequiredText
                v-model="vmodel1.ambCustomtags[index].label"
                :id="'Lable' + index"
                :placeholder="lmodel.ambEnableLabelPlaceholder"
                @update:modelValue="validateCustomTag()"
                :class="{
                'p-invalid':
                  customErrorMessage[index] && customErrorMessage[index].label,
              }"
                :PropName="lmodel.ambEnableLabel"
              ></InputRequiredText>
              <span
                v-if="
                customErrorMessage &&
                customErrorMessage[index] &&
                customErrorMessage[index].label
              "
                :id="`label ${index}-help`"
                class="p-error text-left mt-2"
              >{{ lmodel.ambEnableLabel + " is Required" }}</span>
            </div>
            <div
              :class="
              index > 0
                ? 'col-12 lg:' +
                  (vmodel1.ambCustomtagstype == 1 || vmodel1.ambCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
                : 'col-12 lg:' +
                  (vmodel1.ambCustomtagstype == 1 || vmodel1.ambCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
            "
            >
              <label
                v-tooltip="lmodel.ambEnableTagToolTip"
                tooltipvalueFor="ambEnableLabel-tooltip"
                labelclass="control-label"
              >{{lmodel.ambEnableTag}}</label>
              <InputRequiredText
                v-model="vmodel1.ambCustomtags[index].tag"
                :id="'Tag' + index"
                :placeholder="lmodel.ambEnableTagPlaceholder"
                :IsCustomTagForRule="true"
                @update:modelValue="validateCustomTag()"
                :class="{
                'p-invalid':
                  customErrorMessage[index] && customErrorMessage[index].tag,
              }"
                :PropName="lmodel.ambEnableTag"
              ></InputRequiredText>

              <span
                v-if="
                customErrorMessage &&
                customErrorMessage[index] &&
                customErrorMessage[index].tag
              "
                :id="`Tag ${index}-help`"
                class="p-error text-left mt-2"
              >{{ lmodel.ambEnableTag + " is Required" }}</span>
            </div>
            <!-- Open Next Input Field -->
            <div
              class="form-group"
              :class="
              index > 0
                ? 'col-12 lg:' +
                  (vmodel1.ambCustomtagstype == 1 || vmodel1.ambCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
                : 'col-12 lg:' +
                  (vmodel1.ambCustomtagstype == 1 || vmodel1.ambCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
            "
              v-show="
              !(vmodel1.ambCustomtagstype == 1) && !(vmodel1.ambCustomtagstype == 3)
            "
            >
              <label
                v-tooltip="lmodel.ambEnableLabelToolTip"
                tooltipvalueFor="ambEnableLabel-tooltip"
                labelclass="control-label"
              >{{lmodel.ambOpnNextDealByTag}}</label>
              <InputRequiredText
                v-model="vmodel1.ambCustomtags[index].opnNextDealByTag"
                :id="'opnNextDealByTag' + opnNextDealByTag"
                :IsCustomTagForRule="true"
                :disabled="
                !vmodel1.ambCustomtags[index].tag ||
                vmodel1.ambCustomtags[index].tag.trim() === '' ||
                !vmodel1.ambCustomtags[index].label ||
                vmodel1.ambCustomtags[index].label.trim() === '' ||
                (!!vmodel1.ambCustomtags[index].redirectToUrl &&
                  vmodel1.ambCustomtags[index].redirectToUrl.trim() !== '')
              "
              ></InputRequiredText>
            </div>

            <!-- Redirect URL Input Field -->
            <div
              class="form-group"
              :class="index > 0 ? 'col-12 lg:col-6' : 'col-12 lg:col-6'"
              v-show="
              !(vmodel1.ambCustomtagstype == 1) && !(vmodel1.ambCustomtagstype == 3)
            "
            >
              <label
                v-tooltip="lmodel.ambEnableLabelToolTip"
                tooltipvalueFor="ambEnableLabel-tooltip"
                labelclass="control-label"
              >{{lmodel.ambRedirectToUrl}}</label>
              <InputRequiredText
                v-model="vmodel1.ambCustomtags[index].redirectToUrl"
                :id="'redirectToUrl' + redirectToUrl"
                :IsCustomTagForRule="true"
                :disabled="
                !vmodel1.ambCustomtags[index].tag ||
                vmodel1.ambCustomtags[index].tag.trim() === '' ||
                !vmodel1.ambCustomtags[index].label ||
                vmodel1.ambCustomtags[index].label.trim() === '' ||
                (!!vmodel1.ambCustomtags[index].opnNextDealByTag &&
                  vmodel1.ambCustomtags[index].opnNextDealByTag.trim() !== '')
              "
              ></InputRequiredText>
            </div>
          </div>
          <div
            class="col-12 lg:col-12"
            v-if="vmodel1.ambEnableSingleSelectOptions"
            style="display: flex; justify-content: center"
          >
            <PrimeButton
              class="btn-add-select"
              icon="pi pi-plus"
              @click="addComponentSingleSelect"
              type="button"
              tabindex="-1"
              label="Add new option"
            ></PrimeButton>
          </div>
        </div>

        <div
          v-show="
            vmodel1.ambEnableSingleSelectOptions &&
            vmodel1.ambEnableSelectOption
          "
        >
          <div
            v-for="(ena, subindex) in vmodel1.ambEnableSelectOption"
            class="grid col-12"
            :key="subindex"
          >
            <div class="col-12 lg:col-6">
              <label
                class="general-settings-textnew"
              >{{ staticData.settings.question }} {{ subindex + 2 }}</label>
            </div>
            <div class="col-12 lg:col-6">
              <PrimeButton
                class="btn-danger"
                style="margin-left: auto; display: flex"
                @click="removeaddSingleSelectOption(subindex)"
                type="button"
                tabindex="-1"
                icon="pi pi-trash"
                label="Remove question"
              ></PrimeButton>
            </div>
            <div class="col-12 lg:col-6 py-0">
              <label for="electOptions" class="general-settings-text">
                {{
                staticData.settings.que
                }}
              </label>
              <InputRequiredText
                v-model="
                  vmodel1.ambEnableSelectOption[subindex].customtagstitle
                "
                class="mt-2"
                autocomplete="nope"
                id="title"
                :placeholder="lmodel.ambCustomTextFieldTitlePlaceholder"
              />
            </div>
            <div class="col-12 lg:col-6 py-0">
              <label for="electOptions" class="general-settings-text">
                {{
                lmodel.ambCustomTextField
                }}
              </label>
              <InputRequiredText
                :class="{ 'p-invalid': errorMessage[subindex] }"
                v-model="
                  vmodel1.ambEnableSelectOption[subindex].customfieldname
                "
                class="mt-2"
                PropName="Custom Text Field"
                autocomplete="nope"
                id="title"
                :placeholder="lmodel.ambCustomTextFieldPlaceholder"
                @update:modelValue="validateCustomTag()"
              />
              <span
                v-if="errorMessage[subindex]"
                class="p-error"
              >The {{ lmodel.ambCustomTextField }} is required</span>
            </div>
            <!-- Toggle btn -->
            <div
              class="grid col-12 lg:col-12 horizontal-align"
              v-show="vmodel1.ambEnableSingleSelectOptions"
            >
              <!-- Req Ans -->

              <div class="col-3 toggle-button toggleblock-btn">
                <ToggleButton
                  v-model="vmodel1.ambEnableSelectOption[subindex].requireAns"
                  onIcon="toggle-on"
                  offIcon="toggle-off"
                  class="toggle-btn"
                />
                <!-- <span
                  :class="{
                    'toggle-on new-tgbtn': toggleBtn[subindex].reqAns,
                    'toggle-off new-tgbtn': !toggleBtn[subindex].reqAns,
                  }"
                  @click="
                    toggleBtn[subindex].reqAns = !toggleBtn[subindex].reqAns
                  "
                ></span>-->
                <label
                  for="electOptions"
                  class="general-settings-textnew ml-2"
                >{{ staticData.settings.req_ans }}</label>
              </div>

              <!-- Drop Down -->
              <div class="col-3 toggle-button toggleblock-btn">
                <ToggleButton
                  v-model="vmodel1.ambEnableSelectOption[subindex].dropdown"
                  onIcon="toggle-on"
                  offIcon="toggle-off"
                  class="toggle-btn"
                />
                <!-- <span
                  :class="{
                    'toggle-on new-tgbtn': toggleBtn[subindex].dropDownBtn,
                    'toggle-off new-tgbtn': !toggleBtn[subindex].dropDownBtn,
                  }"
                  @click="
                    toggleBtn[subindex].dropDownBtn =
                      !toggleBtn[subindex].dropDownBtn
                  "
                ></span>-->
                <label
                  for="electOptions"
                  class="general-settings-textnew ml-2"
                >{{ staticData.settings.dropdown }}</label>
              </div>

              <div class="col-3 toggle-button toggleblock-btn">
                <ToggleButton
                  v-model="vmodel1.ambEnableSelectOption[subindex].multiAns"
                  onIcon="toggle-on"
                  offIcon="toggle-off"
                  class="toggle-btn"
                />
                <!-- <span
                  :class="{
                    'toggle-on new-tgbtn': toggleBtn[subindex]?.multipleAns,
                    'toggle-off new-tgbtn': !toggleBtn[subindex]?.multipleAns,
                  }"
                  @click="
                    toggleBtn[subindex].multipleAns =
                      !toggleBtn[subindex]?.multipleAns
                  "
                ></span>-->
                <label
                  for="electOptions"
                  class="general-settings-textnew ml-2"
                >{{ staticData.settings.multiple_ans }}</label>
              </div>
            </div>

            <!-- Options -->
            <!-- -------------------------- -->
            <div
              v-for="(ena, index) in vmodel.ambEnableSelectOption[subindex]
                .customtags"
              class="grid col-12"
              :key="index"
            >
              <div class="col-12 lg:col-6">
                <label
                  class="general-settings-textnew"
                >{{ staticData.settings.option }} {{ index + 1 }}</label>
              </div>
              <div class="col-12 lg:col-6" style="display: flex; justify-content: flex-end">
                <PrimeButton
                  id="cancelbtn"
                  name="Cancel"
                  icon="pi pi-trash"
                  @click="removeComponentSelect(subindex, index)"
                  label="Remove option"
                  class="btn-danger"
                />
              </div>
              <div class="col-12 lg:col-6 py-0">
                <label class="control-label">{{ lmodel.ambEnableLabel }}</label>
                <InputRequiredText
                  v-model="
                    vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .label
                  "
                  :class="{
                    'p-invalid':
                      selectOptErrorMessage[subindex] &&
                      selectOptErrorMessage[subindex][index] &&
                      selectOptErrorMessage[subindex][index].label,
                  }"
                  :PropName="lmodel.ambEnableLabel"
                  :id="'Lable' + index"
                  @update:modelValue="updateCustomTag(subindex)"
                ></InputRequiredText>
                <span
                  v-if="
                    selectOptErrorMessage &&
                    selectOptErrorMessage[subindex] &&
                    selectOptErrorMessage[subindex][index] &&
                    selectOptErrorMessage[subindex][index].label
                  "
                  :id="`label ${index}-help`"
                  class="p-error text-left mt-2"
                >{{ lmodel.ambEnableLabel + " is Required" }}</span>
              </div>
              <div class="col-12 lg:col-6 py-0">
                <label class="control-label">{{ lmodel.ambEnableTag }}</label>
                <InputRequiredText
                  v-model="
                    vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .tag
                  "
                  :id="'Tag' + index"
                  :PropName="lmodel.ambEnableTag"
                  :class="{
                    'p-invalid':
                      selectOptErrorMessage[subindex] &&
                      selectOptErrorMessage[subindex][index] &&
                      selectOptErrorMessage[subindex][index].tag,
                  }"
                  @update:modelValue="updateCustomTag(subindex)"
                ></InputRequiredText>
                <span
                  v-if="
                    selectOptErrorMessage &&
                    selectOptErrorMessage[subindex] &&
                    selectOptErrorMessage[subindex][index] &&
                    selectOptErrorMessage[subindex][index].tag
                  "
                  :id="`tag ${index}-help`"
                  class="p-error text-left mt-2"
                >{{ lmodel.ambEnableTag + " is Required" }}</span>
              </div>
              <div
                class="col-12 lg:col-6 form-group py-0"
                v-if="!vmodel1.ambEnableSelectOption[subindex].multiAns"
              >
                <label class="control-label">{{ lmodel.ambOpnNextDealByTag }}</label>
                <InputRequiredText
                  v-model="
                    vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .opnNextDealByTag
                  "
                  :id="'opnNextDealByTag' + opnNextDealByTag"
                  :IsCustomTagForRule="true"
                  :disabled="
                    !vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .tag ||
                    vmodel1.ambEnableSelectOption[subindex].customtags[
                      index
                    ].tag.trim() === '' ||
                    !vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .label ||
                    vmodel1.ambEnableSelectOption[subindex].customtags[
                      index
                    ].label.trim() === '' ||
                    (!!vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .redirectToUrl &&
                      vmodel1.ambEnableSelectOption[subindex].customtags[
                        index
                      ].redirectToUrl.trim() !== '')
                  "
                ></InputRequiredText>
              </div>
              <div
                class="col-12 lg:col-6 form-group py-0"
                v-if="!vmodel1.ambEnableSelectOption[subindex].multiAns"
              >
                <label class="control-label">{{ lmodel.ambRedirectToUrl }}</label>
                <InputRequiredText
                  v-model="
                    vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .redirectToUrl
                  "
                  :id="'redirectToUrl' + redirectToUrl"
                  :IsCustomTagForRule="true"
                  :disabled="
                    !vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .tag ||
                    vmodel1.ambEnableSelectOption[subindex].customtags[
                      index
                    ].tag.trim() === '' ||
                    !vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .label ||
                    vmodel1.ambEnableSelectOption[subindex].customtags[
                      index
                    ].label.trim() === '' ||
                    (!!vmodel1.ambEnableSelectOption[subindex].customtags[index]
                      .opnNextDealByTag &&
                      vmodel1.ambEnableSelectOption[subindex].customtags[
                        index
                      ].opnNextDealByTag.trim() !== '')
                  "
                ></InputRequiredText>
              </div>
            </div>
            <div
              class="col-12 lg:col-12"
              v-if="vmodel1.ambEnableSelectOption"
              style="display: flex; justify-content: center"
            >
              <PrimeButton
                class="btn-add-select"
                icon="pi pi-plus"
                @click="addComponentSelect(subindex)"
                type="button"
                tabindex="-1"
                label="Add new option"
              ></PrimeButton>
            </div>
            <!-- </div> -->
          </div>
        </div>

        <!--Display Consent-->

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="electOptions"
              class="general-settings-textlabel"
              v-tooltip="lmodel.ambEnableConsentsToolTip"
            >{{ lmodel.ambEnableConsents }}</label>
          </div>

          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambEnableConsents"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': enableConcents,
                    'toggle-off': !enableConcents,
                  }"
                  @click="enableConcents = !enableConcents"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 lg:col-12" v-if="vmodel1.ambEnableConsents">
            <PrimeButton
              class="btn-add-select"
              icon="pi pi-plus"
              label="Add Consents"
              @click="addConsentsDropdown()"
              type="button"
              tabindex="-1"
            ></PrimeButton>
          </div>
        </div>

        <div class="col-12" v-if="isOpenDropdown || this.$route.params.id">
          <div v-for="(ambConsents, index) in this.vmodel1.ambConsents" :key="index">
            <div class="grid">
              <div class="col-12 lg:col-6">
                <span class="general-settings-text">Select consents</span>
              </div>
              <div class="col-12 lg:col-6 py-0" style="display: flex; justify-content: flex-end">
                <PrimeButton
                  class="btn-danger"
                  @click="removeConsentsDropdown(index)"
                  type="button"
                  tabindex="-1"
                  label="Remove Consents"
                />
              </div>
            </div>
            <div class="grid">
              <div class="col-12 lg:col-6 py-0">
                <DropDownRequire
                  v-model="ambConsents.id"
                  :options="getFilteredOptions(index)"
                  id="ambConsents"
                  class="mt-2 dropdown flex-grow-1"
                  optionLabel="name"
                  optionValue="value"
                  @change="updateSelected(ambConsents, index)"
                ></DropDownRequire>
              </div>
            </div>
            <div v-if="ambConsents.id !== null" class="grid mt-2">
              <div class="col-12 lg:col-6">{{ getOptionText(ambConsents.id) }}</div>
              <div class="col-3 toggle-button toggleblock-btn">
                <ToggleButton
                  v-model="ambConsents.req"
                  onIcon="toggle-on"
                  offIcon="toggle-off"
                  class="toggle-btn"
                />
                <label for="electOptions" class="general-settings-textnew ml-2">Required</label>
              </div>
              <div class="col-3 toggle-button toggleblock-btn">
                <ToggleButton
                  v-model="ambConsents.defaultSelected"
                  onIcon="toggle-on"
                  offIcon="toggle-off"
                  class="toggle-btn"
                />
                <label for="electOptions" class="general-settings-textnew ml-2">Default selected</label>
              </div>
              <div class="col-12 lg:col-4">
                <span>Display Text: {{ ambConsents.displayText }}</span>
              </div>
              <div class="col-12 lg:col-4">
                <span>Link Text: {{ ambConsents.linkText }}</span>
              </div>
              <div class="col-12 lg:col-4">
                <span>Condition Text: {{ ambConsents.conditionText }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-6">
            <label for="emailVerification" class="general-settings-text">
              {{
              lmodel.ambrevfcc
              }}
            </label>
          </div>
          <div class="col-12 lg:col-5"></div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambrevfcc"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': req_email,
                    'toggle-off': !req_email,
                  }"
                  @click="req_email = !req_email"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid col-12 mt-2">
          <span class="general-settings-text">
            {{
            staticData.settings.pos_page
            }}
          </span>
        </div>
        <div class="grid">
          <div class="col-12">
            <DropDownRequire
              :options="PositionOptions"
              id="SiteId"
              placeholder="Go to maximized view"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              v-model="positionSelect"
              editable
              :disabled="true"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid mt-2">
          <div class="col-12">
            <span class="text-value">{{ staticData.settings.offsetedge }}</span>
          </div>
          <div class="col-12 py-0">
            <label for="off_widget" class="control-label">
              {{
              staticData.settings.vertical
              }}
            </label>
            <InputText v-model="voffset" id="voffset" class="mt-1"></InputText>
          </div>
        </div>

        <!-- Text Fields -->
        <div class="grid mt-2">
          <div class="col-12 lg:col-12">
            <span class="general-text">{{ lmodel.texts }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 py-0">
            <label
              for="ambassadorSaveCodeSubject-tooltip"
              class="control-label"
            >{{ staticData.settings.heading }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.ambcustomerCheckoutWelcomeTitle"
              :validation="valmodel.ambcustomerCheckoutWelcomeTitle"
              id="CustomerCheckoutWelcomeTitle"
              PropName="Header"
              class="mt-1"
              :placeholder="lmodel.ambCheckoutWelcomeTitlePlaceholder"
            ></InputRequiredTextArea>
          </div>

          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="ambCheckoutWelcomeTitle-tooltip"
            >{{ staticData.settings.body_text }}</label>
            <InputRequiredTextArea
              :validation="valmodel.ambcustomerCheckoutWelcomeBody"
              v-model="vmodel1.ambcustomerCheckoutWelcomeBody"
              id="CustomerCheckoutWelcomeBody"
              PropName="Body Text"
              class="mt-1"
              :placeholder="lmodel.ambCheckoutWelcomeBodyPlaceholder"
            ></InputRequiredTextArea>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="ambCheckoutWelcomeTitle-tooltip"
            >{{ staticData.settings.continue_btn }}</label>
            <InputRequiredText
              v-model="cntbtnValue"
              id="CustomerCheckoutWelcomeTitle"
              PropName="Widget Header"
              class="mt-1"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="ambCheckoutWelcomeTitle-tooltip"
            >{{ staticData.settings.heading_step }}</label>
            <Textarea
              v-model="vmodel1.ambnotCombinedWidgetHeader"
              id="CustomerCheckoutWelcomeTitle"
              PropName="Widget Header"
              class="mt-1"
            ></Textarea>
          </div>
        </div>

        <!--Store Policy and Context-->
        <div class="grid mt-2">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">{{ lmodel.setStorePolicyTitle }}</span>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowCTAbuttonwidth"
              class="general-settings-textlabel"
            >{{ lmodel.ambRequireOptIn }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambIsRequireOptIn"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': requireOpt,
                    'toggle-off': !requireOpt,
                  }"
                  @click="requireOpt = !requireOpt"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowCTAbuttonwidth"
              class="general-settings-textlabel"
            >{{ lmodel.setMoveTermsTextUnderWidget }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.setMoveTermsTextUnderWidget"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': moveTermsText,
                    'toggle-off': !moveTermsText,
                  }"
                  @click="moveTermsText = !moveTermsText"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowCTAbuttonwidth"
              class="general-settings-textlabel"
            >{{ lmodel.setShowConsentTextAlways }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.setShowConsentTextAlways"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': showConsentText,
                    'toggle-off': !showConsentText,
                  }"
                  @click="showConsentText = !showConsentText"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowCTAbuttonwidth"
              class="general-settings-textlabel"
            >{{ lmodel.ambRequireconsent }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambRequireconsent"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': requireconsent,
                    'toggle-off': !requireconsent,
                  }"
                  @click="requireconsent = !requireconsent"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              v-tooltip="lmodel.setAmbassadorOptInYesToolTip"
            >{{ lmodel.setAmbassadorOptInYes }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.setAmbassadorOptInYes"
              id="CustomerCheckoutWelcomeTitle"
              class="mt-1"
            ></InputRequiredTextArea>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              v-tooltip="lmodel.setAmbassadorOptInNoToolTip"
            >{{ lmodel.setAmbassadorOptInNo }}</label>
            <InputRequiredTextArea v-model="vmodel1.setAmbassadorOptInNo" id="OptInNo" class="mt-1"></InputRequiredTextArea>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              v-tooltip="lmodel.ambassadorTermConsentTextToolTip"
            >{{ lmodel.ambassadorTermConsentText }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.ambassadorTermConsentText"
              id="TermConsentText"
              class="mt-1"
            ></InputRequiredTextArea>
          </div>
        </div>

        <!--Contact Integration-->

        <div class="grid mt-2">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">{{ lmodel.setCiSectionTitle }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-6">
            <label
              class="control-label"
              v-tooltip="lmodel.ambVoyadoMemberTypeToolTip"
            >{{ lmodel.ambVoyadoMemberType }}</label>
            <DropDownRequire
              :options="dmodel.ambassadorFriend.voyadoMemberTypeListItems"
              id="SiteId"
              optionLabel="text"
              optionValue="value"
              class="drop-down-val"
              editable
              v-model="vmodel1.ambvoyadoMemberType"
            ></DropDownRequire>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ambVoyadoExternalId"
              v-tooltip="lmodel.ambVoyadoExternalIdToolTip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.ambVoyadoExternalId }}</label>
            <InputText
              id="VoyadoExternalId"
              type="text"
              autocomplete="off"
              :placeholder="lmodel.ambVoyadoExternalIdPlaceholder"
              v-model="vmodel1.ambvoyadoExternalId"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ciTag"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.setCiTagToolTip"
            >{{ lmodel.setCiTag }}</label>
            <InputText
              id="CiTag"
              type="text"
              autocomplete="off"
              :placeholder="lmodel.setCiTagPlaceholder"
              v-model="vmodel1.ciTag"
            ></InputText>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-6">
            <label
              for="ciFieldName"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambciFieldNameToolTip"
            >{{ lmodel.ambciFieldName }}</label>
            <InputRequiredText
              :validation="valmodel.ambciFieldName"
              id="CiFieldName"
              type="text"
              :PropName="lmodel.ambciFieldName"
              autocomplete="off"
              :placeholder="lmodel.ambciFieldNamePlaceholder"
              v-model="vmodel1.ambciFieldName"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ciFieldName"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambciFieldValueToolTip"
            >{{ lmodel.ambciFieldValue }}</label>
            <InputRequiredText
              :validation="valmodel.ambciFieldValue"
              :PropName="lmodel.ambciFieldValue"
              v-model="vmodel1.ambciFieldValue"
              id="CiFieldName"
              type="text"
              autocomplete="off"
              :placeholder="lmodel.ambciFieldValuePlaceholder"
            ></InputRequiredText>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowCTAbuttonwidth"
              class="general-settings-textlabel"
            >{{ lmodel.setBlockFlowAPIError }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.setBlockFlowAPIError"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': blockFlowAPIError,
                    'toggle-off': !blockFlowAPIError,
                  }"
                  @click="blockFlowAPIError = !blockFlowAPIError"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid" v-if="vmodel1.setBlockFlowAPIError">
          <div class="col-12 lg:col-6">
            <label
              for="ambContinuePopupButton"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.setBlockFlowErrorHeaderToolTip"
            >{{ lmodel.setBlockFlowErrorHeader }}</label>
            <InputText
              id="CustomerInfoBlockButtonLabel"
              type="text"
              class="mt-1"
              autocomplete="off"
              :placeholder="lmodel.setBlockFlowErrorHeaderPlaceholder"
              v-model="vmodel1.setBlockFlowErrorHeader"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="blockFlowErrorMsg"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.setBlockFlowErrorMsgToolTip"
            >{{ lmodel.setBlockFlowErrorMsg }}</label>
            <InputText
              id="BlockFlowErrorMsg"
              type="text"
              class="mt-1"
              autocomplete="off"
              :placeholder="lmodel.setBlockFlowErrorMsgPlaceholder"
              v-model="vmodel1.setBlockFlowErrorMsg"
            ></InputText>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowupdatefield"
              class="general-settings-textlabel"
            >{{ lmodel.setAllowupdatefield }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.setAllowupdatefield"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': allowupdatefield,
                    'toggle-off': !allowupdatefield,
                  }"
                  @click="allowupdatefield = !allowupdatefield"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowupdatefieldPrefill"
              class="general-settings-textlabel"
            >{{ lmodel.setAllowupdatefieldForPrefill }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.setaufforprefill"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': allowupdatefieldPrefill,
                    'toggle-off': !allowupdatefieldPrefill,
                  }"
                  @click="allowupdatefieldPrefill = !allowupdatefieldPrefill"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 mt-1">
            <label
              class="control-label"
              for="ciErrorHeader"
              v-tooltip="lmodel.setciErrorHeaderToolTip"
            >{{ lmodel.setciErrorHeader }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.ciErrorHeader"
              :validation="valmodel.ciErrorHeader"
              type="text"
              class="w-full"
              autocomplete="off"
              :PropName="lmodel.setciErrorHeader"
              id="ciErrorHeader"
              :placeholder="lmodel.setciErrorHeaderPlaceholder"
            ></InputRequiredTextArea>
          </div>
          <div class="col-12 lg:col-12 mt-1">
            <label
              class="control-label"
              for="ciErrorMessage"
              v-tooltip="lmodel.setciErrorMessageToolTip"
            >{{ lmodel.setciErrorMessage }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.ciErrorMessage"
              :validation="valmodel.ciErrorMessage"
              type="text"
              id="ciErrorMessage"
              :PropName="lmodel.setciErrorMessage"
              class="mt-1"
              :placeholder="lmodel.setciErrorMessagePlaceholder"
            ></InputRequiredTextArea>
          </div>
        </div>

        <!--Popup Button Text-->
        <div class="grid mt-2">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">{{ lmodel.ambassadorPopupButtonTextTitle }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-6">
            <label
              for="ambContinuePopupButton"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambContinuePopupButtonToolTip"
            >{{ lmodel.ambContinuePopupButton }}</label>
            <InputText
              id="CustomerInfoBlockButtonLabel"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.ambCustomerInfoBlockButtonLabel"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ambSendReferral"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambSendReferralToolTip"
            >{{ lmodel.ambSendReferral }}</label>
            <InputText
              id="CustomerInfoBlockButtonLabel"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.ambMailScreenButtonLable"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ambChooseAnotherChannel"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambChooseAnotherChannelToolTip"
            >{{ lmodel.ambChooseAnotherChannel }}</label>
            <InputText
              id="ChooseAnotherChannel"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.ambCustomerInfoChooseWay"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ambFinishButton"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambFinishButtonToolTip"
            >{{ lmodel.ambFinishButton }}</label>
            <InputText
              id="customerInfoDoneButton"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.ambCustomerInfoDoneButtonLabel"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ambCloseButton"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambassadorCloseButtonToolTip"
            >{{ lmodel.ambFirstCloseButton }}</label>
            <InputText
              id="CloseButton"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.ambassadorCloseButton"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ambSLCTAButton"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambassadorSLCTAButtonToolTip"
            >{{ lmodel.ambassadorSLCTAButton }}</label>
            <InputText
              id="SLCTAButton"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.ambassadorSLCTAButton"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ambInfoTargetChoose"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.ambInfoTargetChooseButtonToolTip"
            >{{ lmodel.ambInfoTargetChooseButton }}</label>
            <InputRequiredText
              :validation="valmodel.ambCustomerInfoTargetChooseBtn"
              v-model="vmodel1.ambCustomerInfoTargetChooseBtn"
              id="ambCustomerInfoTargetChooseBtn"
              PropName="Ambassador Info Target Choose Button"
              :placeholder="lmodel.ambInfoTargetChooseButtonPlaceholder"
              class="mt-1"
            ></InputRequiredText>
          </div>
        </div>
      </TabPanel>
      <!-- Styling  -->
      <TabPanel header="Styling" v-if="lmodel !== null && vmodel !== null">
        <!-- Heading -->
        <div class="grid">
          <div class="col-12 lg:col-12 mt-1">
            <span class="general-settings-text">{{ staticData.styling.heading }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <DropDownRequire
              :options="TextOptions"
              id="SiteId"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              editable
              v-model="selectedOptionText"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <span class="p-inputgroup-add">
                <i class="value-icon"></i>
              </span>
              <InputText
                id="SiteId"
                :class="{
                  'p-invalid': !valmodel.fontsizefortitle,
                }"
                v-tooltip="lmodel.setFontsizefortitleToolTip"
                v-model="vmodel1.fontsizefortitle"
                editable
                class="input-border border-icon"
              ></InputText>
            </div>
            <div>
              <button @click="increaseValue" class="up-btn">
                <i class="pi pi-chevron-up ar-color"></i>
              </button>
              <button @click="decreaseValue" class="down-btn">
                <i class="pi pi-chevron-down ar-color"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="grid col-12">
          <div
            v-if="
              valmodel.fontsizefortitle.$invalid &&
              valmodel.fontsizefortitle.$dirty
            "
            class="col-6 lg:col-6 p-error"
          >
            <span>Minimum value allowed is 0,Maximum value allowed is 999</span>
          </div>
        </div>
        <!-- Body Text -->
        <div class="grid">
          <div class="col-12 lg:col-12 mt-2">
            <span class="general-settings-text">{{ staticData.styling.text }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <DropDownRequire
              :options="TextOptionsbody"
              id="SiteId"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              editable
              v-model="selectedOptionBody"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <span class="p-inputgroup-add">
                <i class="value-icon"></i>
              </span>
              <InputText
                id="SiteId"
                :class="{
                  'p-invalid': !valmodel.fontsizeformsg,
                }"
                v-tooltip="lmodel.setFontsizeformsgToolTip"
                v-model="vmodel1.fontsizeformsg"
                class="input-border border-icon"
                editable
              ></InputText>
            </div>
            <div>
              <button @click="increaseValuetext" class="up-btn">
                <i class="pi pi-chevron-up ar-color"></i>
              </button>
              <button @click="decreaseValuetext" class="down-btn">
                <i class="pi pi-chevron-down ar-color"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="grid col-12">
          <div
            v-if="
              valmodel.fontsizeformsg.$invalid && valmodel.fontsizeformsg.$dirty
            "
            class="col-6 lg:col-6 p-error"
          >
            <span>Minimum value allowed is 0,Maximum value allowed is 999</span>
          </div>
        </div>
        <!-- Button -->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">{{ staticData.styling.button }}</span>
          </div>
        </div>
        <!-- Button Size-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.buttonsize }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="border-box">
              <PrimeButton
                label="Full Width"
                class="rwd-btn"
                :class="{ 'active-btn': selectedButtonSize === 'fullwidth' }"
                @click="selectedButtonSize = 'fullwidth'"
                id="fullwidth"
              ></PrimeButton>

              <PrimeButton
                label="Fit to text"
                class="rwd-btn1"
                :class="{ 'active-btn': selectedButtonSize === 'fittotext' }"
                @click="selectedButtonSize = 'fittotext'"
                id="fittotext"
              ></PrimeButton>
            </div>
          </div>
        </div>
        <!-- Text Size-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.textsize }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <span class="p-inputgroup-add">
                <i class="value-icon"></i>
              </span>
              <InputText
                id="SiteId"
                :class="{
                  'p-invalid': !valmodel.fontsizeforcta,
                }"
                v-tooltip="lmodel.setFontsizeforctaToolTip"
                v-model="vmodel1.fontsizeforcta"
                class="input-border border-icon"
                editable
              ></InputText>
            </div>
            <div>
              <button @click="increaseValuetextsize" class="up-btn">
                <i class="pi pi-chevron-up ar-color"></i>
              </button>
              <button @click="decreaseValuetextsize" class="down-btn">
                <i class="pi pi-chevron-down ar-color"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="grid col-12">
          <div
            v-if="
              valmodel.fontsizeforcta.$invalid && valmodel.fontsizeforcta.$dirty
            "
            class="col-6 lg:col-6 p-error"
          >
            <span>Minimum value allowed is 0,Maximum value allowed is 999</span>
          </div>
        </div>
        <!-- Button shape-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.shape }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="border-box">
              <PrimeButton
                label="Square"
                class="rwd-btn"
                :class="{ 'active-btn': selectedButtonShape === 'square' }"
                @click="selectedButtonShape = 'square'"
                id="square"
              ></PrimeButton>

              <PrimeButton
                label="Rounded"
                class="rwd-btn1"
                :class="{ 'active-btn': selectedButtonShape === 'rounded' }"
                @click="selectedButtonShape = 'rounded'"
                id="rounded"
              ></PrimeButton>

              <PrimeButton
                label="Pill"
                class="rwd-btn1"
                :class="{ 'active-btn': selectedButtonShape === 'pill' }"
                @click="selectedButtonShape = 'pill'"
                id="pill"
              ></PrimeButton>

              <PrimeButton
                label="..."
                class="rwd-btn1"
                :class="{ 'active-btn': selectedButtonShape === '...' }"
                @click="selectedButtonShape = '...'"
                id="..."
              ></PrimeButton>
            </div>
          </div>
        </div>
        <!-- Button shape-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.buttoncolor }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-4"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="4"
              ref="colorPicker4"
            >
              <div class="border-box-color">
                <div
                  class="col-6 statictext"
                  v-tooltip="lmodel.setPopupButtonTextColorToolTip"
                >{{ lmodel.setPopupButtonTextColor }}</div>
                <div class="col-6 labeltext">{{ vmodel1.popupButtonTextColor }}</div>
              </div>
              <span class="p-inputgroup-addon input-border" @click="toggleColorPicker(4)">
                <span
                  id="popupButtonBackgroundColor"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="'background-color: ' + vmodel1.popupButtonTextColor"
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[4]"
                v-model="vmodel1.popupButtonTextColor"
                @update:modelValue="
                  vmodel1.popupButtonTextColor =
                    vmodel1.popupButtonTextColor.hex8
                "
              />
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-5"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="5"
              ref="colorPicker5"
            >
              <div class="border-box-color">
                <div class="col-6 statictext">{{ staticData.styling.buttonbackground }}</div>
                <div class="col-6 labeltext">{{ vmodel1.popupButtonBackgroundColor }}</div>
              </div>
              <span class="p-inputgroup-addon input-border" @click="toggleColorPicker(5)">
                <span
                  id="vmodel1.settings.popupButtonBackgroundColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="
                    'background-color: ' + vmodel1.popupButtonBackgroundColor
                  "
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[5]"
                v-model="vmodel1.popupButtonBackgroundColor"
                @update:modelValue="
                  vmodel1.popupButtonBackgroundColor =
                    vmodel1.popupButtonBackgroundColor.hex8
                "
              />
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowCTAbuttonwidth"
              class="general-settings-textlabel"
            >{{ lmodel.setAllowCTAbuttonwidth }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambIsHighlightAmbassadorCTAButton"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                :class="{
                  'toggle-on': ctaBtn,
                  'toggle-off': !ctaBtn,
                }"
                @click="ctaBtn = !ctaBtn"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid mb-1">
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambIsHighlightAmbassadorCTAButton">
            <InputRequiredNumber
              :validation="valmodel.setCTAbuttonwidth"
              v-model="vmodel1.setCTAbuttonwidth"
              id="setCTAbuttonwidth"
              autocomplete="off"
              class="mt-1"
              MaxValue="300"
            />
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambIsHighlightAmbassadorCTAButton"></div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="allowCTAbuttonwidth"
              class="general-settings-textlabel"
            >{{ lmodel.ambEmbedMaxWid }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <label>
              <div class="toggle-button toggleblock-btn">
                <span
                  :class="{
                    'toggle-on': embedMaxWid,
                    'toggle-off': !embedMaxWid,
                  }"
                  @click="embedMaxWid = !embedMaxWid"
                ></span>
              </div>
            </label>
          </div>
        </div>
        <!-- Widget-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">{{ staticData.styling.widget }}</span>
          </div>
        </div>
        <!-- Colors-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.colors }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-6"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="6"
              ref="colorPicker6"
            >
              <div class="border-box-color">
                <div
                  class="col-6 statictext"
                  v-tooltip="lmodel.setWidgetBackgroundColorToolTip"
                >{{ lmodel.setWidgetBackgroundColor }}</div>
                <div class="col-6 labeltext">{{ vmodel1.widgetBackgroundColor }}</div>
              </div>
              <span class="p-inputgroup-addon input-border" @click="toggleColorPicker(6)">
                <span
                  id="popupButtonBackgroundColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="'background-color: ' + vmodel1.widgetBackgroundColor"
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[6]"
                v-model="vmodel1.widgetBackgroundColor"
                @update:modelValue="
                  vmodel1.widgetBackgroundColor =
                    vmodel1.widgetBackgroundColor.hex8
                "
              />
            </div>
          </div>
        </div>
        <!-- Rounded Corners-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.roundedcorner }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-11 lg:col-11 flex">
            <div class="p-inputgroup">
              <span class="p-inputgroup-add">
                <i class="radius-icon"></i>
              </span>
              <InputText
                id="SiteId"
                :class="{
                  'p-invalid': !valmodel.widgetCornerRound,
                }"
                v-tooltip="lmodel.setWidgetCornerRoundToolTip"
                v-model="vmodel1.widgetCornerRound"
                class="input-border border-icon"
                editable
              ></InputText>
            </div>
            <button class="hrs-btn">{{ staticData.styling.buttonpx }}</button>
            <div>
              <button @click="increaseValuepx" class="up-btn">
                <i class="pi pi-chevron-up ar-color"></i>
              </button>
              <button @click="decreaseValuepx" class="down-btn">
                <i class="pi pi-chevron-down ar-color"></i>
              </button>
            </div>
          </div>
          <div class="col-1">
            <span class="p-inputgroup-addon float" @click="toggleInputs">
              <i class="subtract-icon"></i>
            </span>
          </div>
        </div>
        <div class="grid col-12">
          <div
            v-if="
              valmodel.widgetCornerRound.$invalid &&
              valmodel.widgetCornerRound.$dirty
            "
            class="col-6 lg:col-6 p-error"
          >
            <span>Minimum value allowed is 0,Maximum value allowed is 999</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-6 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-icon"></i>
            </span>
            <InputText id="SiteId" placeholder="0" class="input-border" editable></InputText>
          </div>
          <div class="col-5 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-right-icon"></i>
            </span>
            <InputText id="SiteId" placeholder="0" class="input-border" editable></InputText>
          </div>
          <div class="col-1" v-show="showInputs">
            <span class="p-inputgroup-addon-radius float">
              <i class="subtractclick-icon"></i>
            </span>
          </div>
          <div class="col-6 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-left-bottom-icon"></i>
            </span>
            <InputText id="SiteId" class="input-border" placeholder="0" editable></InputText>
          </div>
          <div class="col-5 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-right-bottom-icon"></i>
            </span>
            <InputText id="SiteId" placeholder="0" class="input-border" editable></InputText>
          </div>
        </div>
        <!-- Shadow Blur-->
        <div class="grid mt-1">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.shadowblur }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <InputText
                id="SiteId"
                :class="{
                  'p-invalid': !valmodel.widgetShadowBlur,
                }"
                v-tooltip="lmodel.setWidgetShadowBlurToolTip"
                v-model="vmodel1.widgetShadowBlur"
                class="border-icon"
                editable
              ></InputText>
            </div>
            <button class="hrs-btn-shadow">{{ staticData.styling.buttonpx }}</button>
          </div>
        </div>
        <div class="grid col-12">
          <div
            v-if="
              valmodel.widgetShadowBlur.$invalid &&
              valmodel.widgetShadowBlur.$dirty
            "
            class="col-6 lg:col-6 p-error"
          >
            <span>Minimum value allowed is 0,Maximum value allowed is 999</span>
          </div>
        </div>
        <!-- Shadow Spread-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.shadowspread }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <InputText id="SiteId" v-model="valueshadowspread" editable></InputText>
            </div>
            <button class="hrs-btn-shadow">{{ staticData.styling.buttonpx }}</button>
          </div>
        </div>
        <!-- Widget Shadow-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.widgetshadow }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-7"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="7"
              ref="colorPicker7"
            >
              <div class="border-box-color">
                <div
                  class="col-6 statictext"
                  v-tooltip="lmodel.setWidgetShadowColorToolTip"
                >{{ lmodel.setWidgetShadow }}</div>
                <div class="col-6 labeltext">{{ vmodel1.setTextColor }}</div>
              </div>
              <span class="p-inputgroup-addon input-border" @click="toggleColorPicker(7)">
                <span
                  id="widgetShadowColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="'background-color: ' + vmodel1.setTextColor"
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[7]"
                v-model="vmodel1.setTextColor"
                @update:modelValue="
                  vmodel1.setTextColor = vmodel1.setTextColor.hex8
                "
              />
            </div>
          </div>
        </div>
      </TabPanel>

      <TabPanel header="Behaviour">
        <div class="grid col-12">
          <span class="general-settings-text">{{ staticData.behaviour.on_click }}</span>
        </div>
        <div class="grid">
          <div class="col-12">
            <DropDownRequire
              :options="Options"
              id="SiteId"
              placeholder="Go to maximized view"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              v-model="optionsSelect"
              editable
              :disabled="true"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid col-12 mt-1">
          <span class="general-settings-text">
            {{
            staticData.behaviour.submit_btn
            }}
          </span>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <RadioButton v-model="selectSubmit" type="radio" :value="0" class="radio-class" />
            <label class="ml-2 checkbox-font">
              <span>{{ staticData.behaviour.always_active }}</span>
            </label>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <RadioButton v-model="selectSubmit" type="radio" :value="1" class="radio-class" />
            <label class="ml-2 checkbox-font">
              <span>{{ staticData.behaviour.active_fieldVal }}</span>
            </label>
          </div>
        </div>
      </TabPanel>
    </TabView>
    <div class="border-line mt-2"></div>
  </div>
</template>

<script>
import TabView from "primevue/tabview";
import staticData from "@/staticdata/static.json";
import { Sketch } from "@ckpack/vue-color";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
// import DataLayerService from "@/services/data-layer.service.js";

export default {
  components: {
    TabView,
    Sketch,
    Cropper
  },

  data() {
    return {
      cropperIsActiveMaxWidDesk: false,
      cropperIsActiveMaxWidMob: false,
      counter: 1,
      ambConsentsDefSelected: false,
      ambConsentsReq: false,
      // hideoptamb: false,
      errorMessage: [],
      customErrorMessage: [],
      selectOptErrorMessage: [],
      ambEnableSelectOption: [],
      //voyadoDynamicConsentsOptions: [],
      isOpenDropdown: false,
      opnNextDealByTag: "",
      redirectToUrl: "",

      staticData: staticData.maximized,
      showInputs: false,
      fNameLName: false,
      imguploaded: false,
      selectedWidgetType: "text",
      selectedImgType: "imgarchive",
      displayimgwidget: true,
      imgurlval: "http://localhost:8080/img/abc.jpg",
      imageUp: "",
      imgurl: false,
      imgarchive: false,
      colorPickerOpen: {
        4: false,
        5: false,
        6: false,
        7: false
      },
      isDisabled: true,
      optionsSelect: "next_step",
      selectSubmit: 0,
      Options: [
        { text: "Go to next step", value: "next_step" },
        { text: "Go to previous step", value: "prev_step" }
      ],
      positionSelect: "bottom_right",
      PositionOptions: [
        { text: "Bottom right", value: "bottom_right" },
        { text: "Bottom left", value: "bottom_left" },
        { text: "Top right", value: "top_right" },
        { text: "Top left", value: "top_left" }
      ],
      imgBorder: false,
      id: this.$route.params.id,
      embedMaxWid: false,
      // choicesBtn: this.vmodel.ambEnableSingleSelectOptions,
      selectedButtonSize: "fullwidth",
      selectedButtonShape: "square",
      valuepx: 0,
      valueshadowblur: 0,
      valueshadowspread: 0,
      valuetext: "0px",
      valuetextsize: "0px",
      selectedOptionText: "SRN",
      selectedOptionBody: "SR",
      TextOptions: [
        { text: "Sora normal", value: "SRN" },
        { text: "Voyado", value: "VY" }
      ],
      TextOptionsbody: [
        { text: "Sora", value: "SR" },
        { text: "Voyado", value: "VY" }
      ],
      voffset: 1,
      cntbtnValue: "1. Continue (Amb)",
      toggleBtn: [],

      // reqAns: false,
      // dropDownBtn: false,
      // multipleAns: false,
      uploadedSuccessfully: "Image uploaded successfully"
    };
  },

  watch: {
    "vmodel1.enableAmbConsents"(newValue) {
      if (!newValue) {
        this.isOpenDropdown = false;
        this.vmodel1.ambConsents = [];
      }
    },
    "vmodel1.ambEnableSelectOption": {
      deep: true,
      async handler(newVal) {
        await this.validateCustomTag();
        newVal.forEach(tagObj => {
          if (
            tagObj.label !== null &&
            tagObj.label !== "" &&
            tagObj.label !== undefined &&
            tagObj.tag !== null &&
            tagObj.tag !== "" &&
            tagObj.tag !== undefined &&
            !tagObj.label.trim() &&
            !tagObj.tag.trim()
          ) {
            tagObj.opnNextDealByTag = "";
            tagObj.redirectToUrl = "";
          }
          return tagObj;
        });
      }
    },
    submitter: {
      deep: true,
      async handler(newVal) {
        if (newVal !== "") {
          await this.validateCustomTag();
        }
      }
    }
  },

  props: {
    dealId: {
      type: String,
      default: null
    },
    tabId: {
      type: Number,
      default: 0
    },
    lmodel: {
      type: Object,
      default: null
    },
    dmodel: {
      type: Object,
      default: null
    },
    vmodel: {
      type: Object,
      default: null
    },
    valmodel: {
      type: Object,
      default: null
    },
    dealStatus: {
      type: Number,
      default: null
    },
    isRedealText: {
      type: Boolean,
      default: false
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false
    },
    modelstate: {
      type: Object,
      default: null
    },
    selectedDeviceType: {
      type: String,
      required: true
    },
    voyadoDomain: {
      type: String,
      default: ""
    },
    voyadoApi: {
      type: String,
      default: ""
    },
    submitter: {
      type: String,
      default: ""
    },
    voyadoDynamicConsentsOptions: {
      type: Array
    }
  },

  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },

    hasAvailableOptions() {
      const selectedValues = this.vmodel1.ambConsents.map(
        ambConsents => ambConsents.id
      );
      const availableOptions = this.voyadoDynamicConsentsOptions.filter(
        option => !selectedValues.includes(option.value)
      );
      return availableOptions.length > 0;
    }
  },

  mounted() {
    this.validateCustomTag();

    document.body.style.overflow = "hidden";
    // if (this.vmodel1.setLanguage && this.voyadoApi && this.voyadoDomain) {
    //   this.GetDynamicConsents();
    // }

    if (this.vmodel1.ambIsHighlightAmbassadorCTAButton == true) {
      this.selectSubmit = 0;
    } else {
      this.selectSubmit = 1;
    }

    if (this.$route.params.id) {
      this.isOpenDropdown = true;
    }

    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  methods: {
    // toggleHideoptamb() {
    //   this.hideoptamb = !this.hideoptamb;
    //   if (this.hideoptamb) {
    //     this.phoneNumber = false;
    //     this.personNumber = false;
    //     this.fullName = false;
    //     this.emailButton = false;
    //     this.fNameLName = false;
    //   } else {
    //     this.emailButton = true;
    //     this.fullName = true;
    //   }
    // },

    validateCustomTag() {
      this.errorMessage = [];
      this.selectOptErrorMessage = [];
      this.customErrorMessage = [];

      for (let i = 0; i < this.vmodel1.ambCustomtags; i++) {
        let obj = {
          label: false,
          tag: false
        };
        this.customErrorMessage.push(obj);
      }
      if (
        this.vmodel1?.ambCustomtags &&
        this.vmodel1?.ambCustomtags.length > 0
      ) {
        if (
          this.submitter !== "" &&
          this.submitter !== null &&
          this.submitter !== undefined
        ) {
          this.vmodel1?.ambCustomtags.map(async (x, index) => {
            if (
              this.vmodel1.ambCustomFieldName !== "" &&
              this.vmodel1.ambCustomFieldName !== null &&
              this.vmodel1.ambCustomFieldName !== undefined
            ) {
              this.customErrorMessage[index].label = true;
              this.customErrorMessage[index].tag = true;
              if (x.label !== "" && x.label !== null && x.label !== undefined) {
                this.customErrorMessage[index].label = false;
              }
              if (x.tag !== "" && x.tag !== null && x.tag !== undefined) {
                this.customErrorMessage[index].tag = false;
              }
            } else {
              this.customErrorMessage[index].label = false;
              this.customErrorMessage[index].tag = false;
            }
          });
        }
      }

      if (
        this.submitter !== "" &&
        this.submitter !== null &&
        this.submitter !== undefined
      ) {
        if (
          this.vmodel1.ambEnableSelectOption &&
          this.vmodel1.ambEnableSelectOption.length > 0
        ) {
          this.vmodel1.ambEnableSelectOption.map((x, index) => {
            if (
              x.customfieldname !== "" &&
              x.customfieldname !== null &&
              x.customfieldname !== undefined
            ) {
              this.errorMessage[index] = false;
            } else {
              this.errorMessage[index] = true;
            }
          });

          for (let i = 0; i < this.vmodel1.ambEnableSelectOption.length; i++) {
            if (!this.selectOptErrorMessage[i]) {
              this.selectOptErrorMessage[i] = [];
            }

            for (
              let j = 0;
              j < this.vmodel1.ambEnableSelectOption[i].customtags.length;
              j++
            ) {
              let obj = {
                label: false,
                tag: false
              };
              this.selectOptErrorMessage[i].push(obj);
            }
          }

          this.vmodel1.ambEnableSelectOption.map((x, index) => {
            x.customtags.map((item, subindex) => {
              if (
                x.customfieldname !== "" &&
                x.customfieldname !== null &&
                x.customfieldname !== undefined
              ) {
                this.selectOptErrorMessage[index][subindex].label = true;
                this.selectOptErrorMessage[index][subindex].tag = true;
                if (
                  item.label !== "" &&
                  item.label !== null &&
                  item.label !== undefined
                ) {
                  this.selectOptErrorMessage[index][subindex].label = false;
                }
                if (
                  item.tag !== "" &&
                  item.tag !== null &&
                  item.tag !== undefined
                ) {
                  this.selectOptErrorMessage[index][subindex].tag = false;
                }
              } else {
                this.errorMessage[index] = true;
                this.selectOptErrorMessage[index][subindex].label = false;
                this.selectOptErrorMessage[index][subindex].tag = false;
              }
            });
          });
        }
      }

      let errorArray = this.errorMessage.includes(true);
      let selectOptErrorMessageArray = this.selectOptErrorMessage.some(row =>
        row.some(obj => obj.label === true || obj.tag === true)
      );

      let customErrorMessageArray = this.customErrorMessage.some(
        obj => obj.label === true || obj.tag === true
      );

      if (errorArray || selectOptErrorMessageArray || customErrorMessageArray) {
        this.$emit("displayError", true);
      } else {
        this.$emit("displayError", false);
      }
    },

    showEmailval() {
      if (!this.vmodel1.ambShowEmail) {
        this.vmodel1.ambEmailText = ""; // Clear emailText
      }
      if (
        this.vmodel1.ambShowPhoneNumber == false &&
        this.vmodel1.ambShowPersonalNumber == false &&
        this.vmodel1.ambShowEmail == false
      ) {
        this.vmodel1.ambHideOptinAmbassador = true;
      }
      // New condition to disable/enable buttons
      if (this.vmodel1.ambHideOptinAmbassador) {
        this.vmodel1.ambShowPhoneNumber = false;
        this.vmodel1.ambShowPersonalNumber = false;
        this.vmodel1.ambShowEmail = false;
      }
      // else {
      //   // Ensure buttons can be clicked again
      // }
    },

    toggleFullName() {
      this.fullName = !this.fullName;
      if (this.fullName) {
        this.fNameLName = false;
      }
    },
    toggleFNameLName() {
      this.fNameLName = !this.fNameLName;
      if (this.fNameLName) {
        this.fullName = false;
      }
    },
    // GetDynamicConsents() {
    //   const apiUrl = `/site/getdynamicconsents?apikey=${this.voyadoApi}&domain=${this.voyadoDomain}&language=${this.vmodel1.setLanguage}`;
    //   DataLayerService.get(apiUrl).then((result) => {
    //     if (result !== null && result !== undefined && result != []) {
    //       this.voyadoDynamicConsentsOptions = result;
    //     }
    //   });
    // },
    addConsentsDropdown() {
      this.isOpenDropdown = true;
      this.vmodel1.ambConsents.push({
        id: null,
        name: null,
        req: false,
        defaultSelected: false,
        conditionText: "",
        displayText: "",
        linkText: ""
      });
    },

    getFilteredOptions(index) {
      const selectedValues = this.vmodel1.ambConsents
        .map((ambConsents, i) => (i === index ? null : ambConsents.id))
        .filter(value => value !== null);

      return this.voyadoDynamicConsentsOptions.filter(
        option => !selectedValues.includes(option.value)
      );
    },

    updateSelected(ambConsents) {
      const selectedOption = this.voyadoDynamicConsentsOptions.find(
        option => option.value === ambConsents.id
      );
      if (selectedOption) {
        ambConsents.id = selectedOption.value;
        ambConsents.name = selectedOption.name;
        ambConsents.displayText = selectedOption.displayText;
        ambConsents.linkText = selectedOption.linkText;
        ambConsents.conditionText = selectedOption.conditionText;
      }
    },

    removeConsentsDropdown(index) {
      this.vmodel1.ambConsents.splice(index, 1);
    },

    getOptionText(value) {
      const option = this.voyadoDynamicConsentsOptions.find(
        opt => opt.value === value
      );
      return option ? `${option.name}` : "";
    },

    //Desktop Max image
    openFileUploadDesktop() {
      this.$refs.filedesktop.choose();
    },
    captureCroppedImageMaxWidDesk() {
      const { canvas } = this.$refs.cropperComponent6.getResult();
      this.vmodel1.ambheaderimagepath = canvas.toDataURL();
      this.vmodel1.ambheaderimagestream = canvas.toDataURL();
      this.croppedImage = this.vmodel1.ambheaderimagepath;
      this.cropperIsActiveMaxWidDesk = false;
    },
    closeCropperMaxWidDesk() {
      this.cropperIsActiveMaxWidDesk = false;
    },
    cropImageMaxDesktop() {
      this.cropperIsActiveMaxWidDesk = true;
    },
    clearImageDesktop() {
      this.$refs.filedesktop.clear();
      this.vmodel1.ambheaderimagestream = null;
      this.vmodel1.ambheaderimagename = null;
      this.vmodel1.ambheaderimagepath = null;
      this.vmodel1.ambdesktimgwdth = 0;
      this.vmodel1.ambdesktimghght = 0;
    },
    replaceFileDesktop() {
      this.$refs.filedesktop.clear();
      this.$refs.filedesktop.choose();
    },
    handleFileUploadDesktop(fileObj) {
      var file = this.$refs.filedesktop.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.ambheaderimagestream = reader.result;
            this.vmodel1.ambheaderimagename = file.name;
            this.vmodel1.ambheaderimagepath = reader.result;
            // this.vmodel1.ambassador.desktimghght = image.height;
            // this.vmodel1.ambassador.desktimgwdth = image.width;
            // if (this.vmodel1.ambassador.desktimgwdth > this.computedwidth) {
            //   this.newwidth = 300;
            // } else {
            //   this.newwidth = this.vmodel1.ambassador.desktimgwdth;
            // }
            // if (this.vmodel1.ambassador.desktimghght > this.computedheight) {
            //   this.newheight = 300;
            // } else {
            //   this.newheight = this.vmodel1.ambassador.desktimghght;
            // }
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },

    //Mobile Max image

    handleFileUpload(fileObj) {
      var file = this.$refs.filemobile.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.ambmobHeaderimagestream = reader.result;
            this.vmodel1.ambmobHeaderimagename = file.name;
            this.vmodel1.ambmobHeaderimagepath = reader.result;
            // this.vmodel1.ambassador.mobimghght = image.height;
            // this.vmodel1.ambassador.mobimgwdth = image.width;
            // if (this.vmodel1.ambassador.mobimgwdth > this.computedwidthmob) {
            //   this.newwidthmob = 300;
            // } else {
            //   this.newwidthmob = this.vmodel1.ambassador.mobimgwdth;
            // }
            // if (this.vmodel1.ambassador.mobimghght > this.computedheightmob) {
            //   this.newheightmob = 300;
            // } else {
            //   this.newheightmob = this.vmodel1.ambassador.mobimghght;
            // }
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    openFileUploadMobile() {
      this.$refs.filemobile.choose();
    },
    removeComponent(index) {
      this.vmodel1.customtags.splice(index, 1);
    },
    replaceFileMobile() {
      this.$refs.filemobile.clear();
      this.$refs.filemobile.choose();
    },
    clearImageMobile() {
      this.$refs.filemobile.clear();
      this.vmodel1.ambmobHeaderimagestream = null;
      this.vmodel1.ambmobHeaderimagename = null;
      this.vmodel1.ambmobHeaderimagepath = null;
    },
    cropImageMaxMobile() {
      this.cropperIsActiveMaxWidMob = true;
    },
    closeCropperMaxWidMob() {
      this.cropperIsActiveMaxWidMob = false;
    },
    captureCroppedImageMaxWidMob() {
      const { canvas } = this.$refs.cropperComponent5.getResult();
      this.vmodel1.ambmobHeaderimagepath = canvas.toDataURL();
      this.vmodel1.ambmobHeaderimagestream = canvas.toDataURL();
      this.croppedImage = this.vmodel1.ambmobHeaderimagepath;

      this.cropperIsActiveMaxWidMob = false;
    },
    updateCustomTag(subindex) {
      this.validateCustomTag();
      if (
        this.vmodel1.ambEnableSelectOption &&
        this.vmodel1.ambEnableSelectOption.length > 0
      ) {
        this.vmodel1.ambEnableSelectOption[
          subindex
        ].customtags = this.vmodel1.ambEnableSelectOption[
          subindex
        ].customtags.map(x => {
          if (x.label == "" && x.tag == "") {
            x.opnNextDealByTag = "";
            x.redirectToUrl = "";
          }
          return x;
        });
      }
    },

    addComponent() {
      this.vmodel1.customtags.push({
        label: "",
        tag: "",
        opnNextDealByTag: "",
        redirectToUrl: ""
      });
      this.counter++;
    },

    removeaddSingleSelectOption(subindex) {
      this.vmodel1.ambEnableSelectOption.splice(subindex, 1);
    },

    addSingleSelectOption() {
      if (this.vmodel1.ambEnableSelectOption.length >= 4) return;
      this.vmodel1.ambEnableSelectOption.push({
        customtagstitle: "",
        customfieldname: "",
        // customtagstype: 0,
        requireAns: false,
        dropdown: false,
        cfldmdtry: false,
        multiAns: false,
        customtags: [
          {
            label: "",
            tag: "",
            opnNextDealByTag: "",
            redirectToUrl: ""
          }
        ]
      });
    },

    removeComponentSelect(subindex, index) {
      this.vmodel1.ambEnableSelectOption[subindex].customtags.splice(index, 1);
    },

    removeSingleComponentSelect(index) {
      if (this.vmodel1.ambCustomtags.length > 1) {
        this.vmodel1.ambCustomtags.splice(index,1);
      }
    },

    addComponentSingleSelect() {
      this.vmodel1.ambCustomtags.push({
        label: "",
        tag: "",
        opnNextDealByTag: "",
        redirectToUrl: ""
      });
      // const scrollHeight =
      //   document.getElementById("option-list").scrollHeight + 35;
      // setTimeout(() => {
      //   document
      //     .getElementById("option-list")
      //     .scrollTo({ left: 0, top: scrollHeight, behavior: "smooth" });
      // }, 100);
    },

    addComponentSelect(subindex) {
      this.vmodel1.ambEnableSelectOption[subindex].customtags.push({
        label: "",
        tag: "",
        opnNextDealByTag: "",
        redirectToUrl: ""
      });
      // const scrollHeight =
      //   document.getElementById("option-list").scrollHeight + 35;
      // setTimeout(() => {
      //   document
      //     .getElementById("option-list")
      //     .scrollTo({ left: 0, top: scrollHeight, behavior: "smooth" });
      // }, 100);
    },
    increaseValue() {
      const numericValue = parseInt(this.vmodel1.fontsizefortitle);
      if (!isNaN(numericValue) && numericValue < 100) {
        this.vmodel1.fontsizefortitle = `${numericValue + 1}`;
      }
    },
    decreaseValue() {
      const numericValue = parseInt(this.vmodel1.fontsizefortitle);
      if (!isNaN(numericValue) && numericValue > 0) {
        this.vmodel1.fontsizefortitle = `${numericValue - 1}`;
      }
    },
    increaseValuetext() {
      const numericValue = parseInt(this.vmodel1.fontsizeformsg);
      if (numericValue < 100) {
        this.vmodel1.fontsizeformsg = numericValue + 1;
      }
    },
    decreaseValuetext() {
      const numericValue = parseInt(this.vmodel1.fontsizeformsg);
      if (numericValue > 0) {
        this.vmodel1.fontsizeformsg = numericValue - 1;
      }
    },
    increaseValuetextsize() {
      const numericValue = parseInt(this.vmodel1.fontsizeforcta);
      if (numericValue < 100) {
        this.vmodel1.fontsizeforcta = numericValue + 1;
      }
    },
    decreaseValuetextsize() {
      const numericValue = parseInt(this.vmodel1.fontsizeforcta);
      if (numericValue > 0) {
        this.vmodel1.fontsizeforcta = numericValue - 1;
      }
    },
    increaseValuepx() {
      if (this.vmodel1.widgetCornerRound < 100) {
        this.vmodel1.widgetCornerRound++;
      }
    },
    decreaseValuepx() {
      if (this.vmodel1.widgetCornerRound > 0) {
        this.vmodel1.widgetCornerRound--;
      }
    },
    toggleInputs() {
      this.showInputs = !this.showInputs;
    },
    toggleColorPicker(id) {
      // Toggle the state of color picker
      this.colorPickerOpen[id] = !this.colorPickerOpen[id];

      // Close other color pickers when one is opened
      for (let key in this.colorPickerOpen) {
        if (key != id) {
          this.colorPickerOpen[key] = false;
        }
      }
    },

    selectWidgetType(value) {
      this.selectedWidgetType = value;
      if (value === "text") {
        this.isText = true;
        this.isImg = false;
      } else if (value === "image") {
        this.isImg = true;
        this.isText = false;
      }
    },
    selectImgType(value) {
      this.selectedImgType = value;
      if (value === "imgurl") {
        this.imgurl = true;
        this.imgarchive = false;
      } else if (value === "imgarchive") {
        this.imgurl = false;
        this.imgarchive = true;
      }
    },

    clearImage() {
      this.imageUp = "";
      this.imguploaded = false;
      this.$refs.photo.clear();
    },

    openFileUpload() {
      this.$refs.photo.choose();
    },
    onAdvancedUpload(fileObj) {
      var file = this.$refs.photo.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.imageUp = reader.result;
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000
            });
          };
          image.src = reader.result;
          if (image.src) {
            this.imguploaded = true;
          }
        };
        reader.readAsDataURL(file);
      }
    },

    handleOutsideClick(event) {
      for (let key in this.$refs) {
        if (key.startsWith("colorPicker")) {
          if (!this.$refs[key].contains(event.target)) {
            const id = parseInt(key.replace("colorPicker", ""), 10);
            this.colorPickerOpen[id] = false;
          }
        }
      }
    },

    addHashPrefix() {
      if (
        this.vmodel1.popupButtonTextColor &&
        !this.vmodel1.popupButtonTextColor.startsWith("#")
      ) {
        this.vmodel1.popupButtonTextColor =
          "#" + this.vmodel1.popupButtonTextColor.toUpperCase();
      } else if (
        this.vmodel1.popupButtonBackgroundColor &&
        !this.vmodel1.popupButtonBackgroundColor.startsWith("#")
      ) {
        this.vmodel1.popupButtonBackgroundColor =
          "#" + this.vmodel1.popupButtonBackgroundColor.toUpperCase();
      } else if (
        this.vmodel1.widgetBackgroundColor &&
        !this.vmodel1.widgetBackgroundColor.startsWith("#")
      ) {
        this.vmodel1.widgetBackgroundColor =
          "#" + this.vmodel1.widgetBackgroundColor.toUpperCase();
      } else if (
        this.vmodel1.setTextColor &&
        !this.vmodel1.setTextColor.startsWith("#")
      ) {
        this.vmodel1.setTextColor =
          "#" + this.vmodel1.setTextColor.toUpperCase();
      } else {
        this.vmodel1.popupButtonTextColor = this.vmodel1.popupButtonTextColor.toUpperCase();
        this.vmodel1.popupButtonBackgroundColor = this.vmodel1.popupButtonBackgroundColor.toUpperCase();
        this.vmodel1.widgetBackgroundColor = this.vmodel1.widgetBackgroundColor.toUpperCase();
        this.vmodel1.setTextColor = this.vmodel1.setTextColor.toUpperCase();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.border-line {
  border-top: 1px solid #e5e5e5;
}

:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
  border: none !important;
  background: #ffffff;
  color: #000000;
  padding: 1rem 1.125rem 0rem;
  font-weight: 400;
  font-size: 14.22px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s, outline-color 0.2s;
  margin: 0 0 -1px 0;
  outline-color: transparent;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
  background: #ffffff;
  // border-color: #dee2e6 !important;
  border: 1px solid #dee2e6 !important;
  border-width: 0px 0px 1px 0px !important;
  color: #000000;
  font-weight: 400;
  font-size: 14.22px;
  line-height: 17.1px;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border: none;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border-bottom: 3px solid #791a3f;
}
:deep(.p-tabview .p-tabview-ink-bar) {
  display: none !important;
}

:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
  background: #ffffff;
  border: 0 none;
  color: #212529;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.setting-layout {
  margin-top: 180px;
  font-family: "Voyado Text";
}
:deep(.setting-layout.p-tabview .p-tabview-panels) {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 260px);
}

:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
}

.general-settings-text {
  font-size: 14.22px !important;
  font-weight: 500 !important;
  line-height: 17.1px !important;
  color: #21211f !important;
}

.general-settings-textlabel {
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  color: #21211f !important;
  height: 18px !important;
}

.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.p-inputgroup > input:first-child {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px;
  border-right: none;
}

.p-inputgroup-add {
  background: #fff !important;
  color: #495057;
  border-bottom: 1px solid #c0c0bc;
  border-top: 1px solid #c0c0bc;
  border-left: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  height: 40px;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.p-inputgroup-addon {
  background: #fff !important;
  color: #495057;
  border-top: 1px solid #c0c0bc;
  // border-left: none;
  border-bottom: 1px solid #c0c0bc;
  padding: 0.5rem 0.75rem;
  /* min-width: 2.357rem; */
  // width: 100%;
  height: 40px;
  // border-top-left-radius: 0px !important;
  // border-bottom-left-radius: 0px !important;
  border-right: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.p-inputgroup-addon-radius {
  background: #9b1c45;
  color: #495057;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  padding: 0.5rem 0.75rem;
  height: 40px;
  border-right: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.input-border {
  border-top-left-radius: 0px !important;
  border-left: none !important;
  border-bottom-left-radius: 0px !important;
}

.border-icon {
  border-right: none !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.float {
  float: right;
}

:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  height: 40px;
  box-shadow: none;
  // border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}

// .custom-input ::v-deep .p-inputtext {
//   border-radius: 0px !important;
//   border-left: none !important;
//   border-right: none !important;
// }

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  // border: 1px solid #cedacf;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.hrs-btn {
  border: none;
  height: 40px !important;
  background-color: #fff;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  color: #797971;
  cursor: text;
}
.down-btn {
  border: 1px solid #c0c0bc;
  background-color: #fff;
  height: 20px;
  width: 30px;
  display: grid;
  border-bottom-right-radius: 4px;
}

.up-btn {
  border: 1px solid #c0c0bc;
  background-color: #fff;
  height: 20px;
  width: 30px;
  display: grid;
  border-top-right-radius: 4px;
}

.ar-color {
  color: #797971 !important;
}

.colorpicker-component {
  position: relative;
}

.p-colorpicker-preview {
  width: 25px !important;
  height: 25px;
}

.vc-sketch {
  position: absolute !important;
  z-index: 1 !important;
  right: 0 !important;
  top: 40px !important;
  width: 200px;
  padding: 10px 10px 0;
  box-sizing: initial;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.15);
}

.current-color {
  display: inline-block;
  width: 28px;
  height: 28px;
  background-color: #000;
  cursor: pointer;
  border: 1px solid #c0c0bc;
  border-radius: 8px;
}
/* Style for the input field */
.colorpicker-input {
  width: 376px !important;
  height: 40px !important;
  padding: 6px 12px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  position: relative;
}
.p-inputtextcolor {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  // border: 1px solid #C0C0BC;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
.p-inputtextcolor::before {
  content: "Shadow color ";
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: black;
}

.p-inputtextcolor::after {
  content: attr(value);
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: black;
}

.p-inputgroup > .p-inputwrapper:last-child > .p-inputtextcolor {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.border-box-color {
  border: 1px solid #c0c0bc;
  height: 40px;
  display: flex;
  width: 100%;
  text-align: center;
  border-right: none !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

// maximized css

.toggle-button {
  display: flex;
  align-items: center;
}
.toggle-button span {
  cursor: pointer;
  vertical-align: middle;
}

.toggleblock-btn {
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
}

.border-box {
  border: 1px solid #c0c0bc;
  height: 40px;
  display: flex;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  // margin-top: inherit !important;
  //   justify-content: center;
}

.upload-text {
  width: 100%;
  height: 24px;
  // font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.checkbox-font {
  margin-left: 4px !important;
  font-family: "Voyado Text" !important;
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  text-align: left !important;
}
.radio-class {
  height: 20 px;
  padding: 4px 0px 0px 0px;
  border-radius: 10px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  background: #ffffff;
}

.deal-img {
  padding: 12px 0px 0px 0px;
}
.general-settings-label {
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  color: #666666;
  font-family: "Voyado Text";
  // text-align: left;
}

.hrs-btn-shadow {
  border: none;
  height: 40px !important;
  background-color: #fff;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-right: 1px solid #c0c0bc;
  color: #797971;
  cursor: text;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.statictext {
  justify-content: left;
  display: flex;
  color: #21211f;
  font-family: "Voyado Text";
  font-size: 14px;
}
.labeltext {
  justify-content: right;
  display: flex;
  color: #21211f;
  font-family: "Voyado Text";
  font-size: 14px;
}

.flex {
  display: flex;
}

:deep(.p-button:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}
.text-value {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 500;
  line-height: 17.1px;
  text-align: left;
  color: #21211f;
}
.general-text {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 500;
  line-height: 17.1px;
  text-align: left;
  color: #21211f;
}
.general-settings-labeltoggale {
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  color: #21211f;
  font-family: "Voyado Text";
  // text-align: left;
}

.btn-add-select {
  background-color: #2d6e6d !important;
  border-color: #2d6e6d !important;
  color: #fff;
  height: 40px;
  padding: 0px 16px 0px 16px;
  font-size: 14.22px;
  width: 500;
  line-height: 12.8px;
  font-family: "Voyado Text";
  border-radius: 4px;
  box-shadow: none;
}
.btn-danger {
  background-color: #fff;
  border: 2px solid #e0e9e8 !important;
  color: #2d6e6d;
  height: 24px;
  padding: 0px 8px 0px 8px;
  font-size: 12.64px;
  line-height: 1.4;
  border-radius: 4px;
  box-shadow: none;
  font-family: "Voyado Text";
}
.btn-danger:hover {
  background-color: #2d6e6d !important;
  border-color: #2d6e6d !important;
}
.p-disabled {
  opacity: 1;
  background-color: #e9ecef !important;
  border: none;
}
.new-tgbtn {
  font-size: 34px !important;
  margin-left: 5px !important;
}
.horizontal-align {
  display: flex;
  align-items: center;
}
:deep(.control-label) {
  font-size: 14px;
  padding-bottom: 3px;
  display: inline-block;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: normal;
  position: relative;
  vertical-align: top;
  color: #21211f;
  font-family: "Voyado Text";
}

.photo-section span {
  margin-top: 8px;
  text-align: center;
}

.imagefit {
  margin-top: 5px;
  width: 500px;
  height: 500px;
  overflow: hidden;
  position: relative;
  max-width: 100%;
  max-height: 100%;
}

:deep(.p-textarea) {
  height: 79px;
}

:deep(.textareaBody) {
  height: 79px !important;
  .p-inputtextarea {
    height: 79px !important;
  }
}

.dropdown {
  flex-grow: 1;
  margin-right: 10px;
}

.con-hei {
  margin-top: 10px;
}
</style>
